import React from "react";
import { Badge } from "@/components/ui/badge";
import { fmt } from "@/pages/admin/utils/format";
import { AdminSearchBar, PaginationFooter } from "@/pages/admin/components/common";

const EmailsSection = ({
  emails,
  emailsInput,
  setEmailsInput,
  emailsMeta,
  emailsPage,
  setEmailsPage,
}) => (
  <>
            <AdminSearchBar
              value={emailsInput}
              onChange={setEmailsInput}
              placeholder="ابحث بالإيميل، الموضوع، النوع، أو رقم الطلب..."
              testId="admin-emails-search"
              resultCount={emailsMeta.total}
            />
            <div className="card-warm p-0 overflow-hidden">
              <table className="w-full text-sm" data-testid="admin-emails-table">
                <thead className="bg-[#F6F4EE] text-[#5E5C58]">
                  <tr>
                    <th className="text-start p-4">إلى</th>
                    <th className="text-start p-4">الموضوع</th>
                    <th className="text-start p-4">النوع</th>
                    <th className="text-start p-4">الحالة</th>
                    <th className="text-start p-4">التاريخ</th>
                  </tr>
                </thead>
                <tbody>
                  {emails.length === 0 && (
                    <tr><td colSpan={5} className="p-6 text-center text-[#5E5C58]">لا توجد رسائل بعد.</td></tr>
                  )}
                  {emails.map((e) => {
                    // Iteration 30 — surface the rich Resend failure fields so
                    // the admin can diagnose without sending more tests.
                    const reason =
                      e.meta?.error_message ||
                      e.meta?.error ||
                      e.meta?.reason ||
                      e.meta?.error_type ||
                      null;
                    const errStatus = e.meta?.error_status;
                    const errCode = e.meta?.error_code;
                    return (
                      <tr key={e.id} className="border-t border-[#E5E1D8]">
                        <td className="p-4" dir="ltr">{e.to}</td>
                        <td className="p-4">{e.subject}</td>
                        <td className="p-4 text-xs text-[#5E5C58]">{e.kind}</td>
                        <td className="p-4">
                          <div className="flex flex-col gap-1">
                            <Badge
                              className={`rounded-full ${e.live ? "bg-emerald-100 text-emerald-800" : "bg-amber-100 text-amber-800"} self-start`}
                              data-testid={`admin-email-status-${e.id}`}
                            >
                              {e.live ? "أُرسلت" : "مسجّلة فقط"}
                            </Badge>
                            {!e.live && reason && (
                              <span
                                className="text-[10px] text-rose-700 max-w-xs whitespace-pre-wrap break-words"
                                title={String(reason)}
                                data-testid={`admin-email-reason-${e.id}`}
                              >
                                سبب الإخفاق: {String(reason)}
                                {errStatus ? ` (HTTP ${errStatus})` : ""}
                                {errCode ? ` [${errCode}]` : ""}
                              </span>
                            )}
                            {e.live && e.provider_id && (
                              <span
                                className="text-[10px] text-emerald-700/70 font-mono"
                                dir="ltr"
                                data-testid={`admin-email-provider-${e.id}`}
                              >
                                {e.provider_id}
                              </span>
                            )}
                          </div>
                        </td>
                        <td className="p-4">{fmt(e.created_at)}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <PaginationFooter
              page={emailsPage}
              totalPages={emailsMeta.total_pages}
              total={emailsMeta.total}
              onPrev={() => setEmailsPage((p) => Math.max(1, p - 1))}
              onNext={() => setEmailsPage((p) => Math.min(emailsMeta.total_pages || 1, p + 1))}
              testId="admin-emails-pager"
            />
  </>
);

export { EmailsSection };
